import Vue from 'vue';

let PageComponent = {
  name: 'bring-a-friend',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let info = document.querySelector('#bring-a-friend');
    if (info) {
      info.remove();
    }

    let url = '/api/templates/info/bring-a-friend';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/info/bring-a-friend/index.js